/**
 * Module dependencies.
 */

import commonDev from 'app/locales/dev/common.json';
import commonEn from 'app/locales/en/common.json';

/**
 * Export `resources`.
 */

export const resources = {
  dev: {
    common: commonDev
  },
  en: {
    common: commonEn
  }
};
